export enum CheckoutState
{
    PaymentMethod = 0,
    GamePlan = 1,
    PaymentPlan = 2,
    Payment = 3,
    Gapfund = 4
}
